<script lang="ts" setup>
const { details } = storeToRefs(useCommerceStore())
</script>

<template>
  <div
    v-show="details.name || details.delivery"
    class="mb-1 grid grid-cols-1 gap-2 rounded-lg bg-white p-2"
  >
    <span v-if="details.name">{{ $t('Client') }}: <b>{{ details.name }}</b></span>
    <span v-if="details.phone">{{ $t('Phone') }}: <b>{{ details.phone }}</b></span>
    <!-- <span v-if="details.table">{{ $t('Table') }}: <b>{{ details.table }}</b></span> -->
    <span v-if="details.delivery">{{ $t('To go') }}: <i class="pi pi-sign-in text-lg" /></span>
    <span v-if="details.comments">{{ $t('Comments') }}: <b>{{ details.comments }}</b></span>
    <span v-if="details.address">{{ $t('Address') }}: <b>{{ details.address }}</b></span>
  </div>
</template>
